const flatMapErrMessagesValidateForm = (err) => [].concat.apply([], ...Object.values(err).map((item) => item.errors)).map((item) => item.message);

const debounceTimeExecute = (args, fn, debounceTime = 800, index = 0) => {
  const arg = args[index];
  fn(arg);
  if (index < args.length - 1) {
    setTimeout(() => {
      debounceTimeExecute(args, fn, debounceTime, index + 1);
    }, debounceTime);
  }
};
const getSiblings = (elem) => {
  const siblings = [];
  let sibling = elem.parentNode.firstChild;
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== elem) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
};
const getMinusSiblingsHeight = (elem) => `${getSiblings(elem).reduce((total, elem) => total + elem.offsetHeight, 0)}px`;
const isCanvasSupported = () => {
  const elem = document.createElement('canvas');
  return !!(elem.getContext && elem.getContext('2d'));
};
const genRandomId = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
    const randomNumber = (Math.random() * 16) | 0;
    const uuidV4 = character == 'x' ? randomNumber : (randomNumber & 0x3) | 0x8;
    return uuidV4.toString(16);
  });
};

const transformSearchParamsToObject = () => {
  const search = location.search.substring(1);
  return JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
};

const indexItemTable = (currentPage, pageSize, indexItemResponse) => (currentPage * pageSize + indexItemResponse + 1) - pageSize;

const formatUtcTime = (value) => {
  return !(/[a-z]$/i).test(value) ? `${value}Z` : value;
}

/**
 * True only for an absolute http: or https: URL. Anything else (javascript:,
 * data:, a relative path, junk) must be rendered as text, never as a link.
 * @param {*} value
 * @returns {boolean}
 */
const isHttpUrl = (value) => {
  try {
    const { protocol } = new URL(String(value));
    return protocol === 'http:' || protocol === 'https:';
  } catch (e) {
    return false;
  }
};

export {
  flatMapErrMessagesValidateForm,
  debounceTimeExecute,
  getSiblings,
  getMinusSiblingsHeight,
  isCanvasSupported,
  genRandomId,
  transformSearchParamsToObject,
  indexItemTable,
  formatUtcTime,
  isHttpUrl
};
